import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

import { CustomSnackbarComponent } from './../components/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private duration = 2500;

  constructor(private snackBar: MatSnackBar) {}

  info = (
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<CustomSnackbarComponent> =>
    this.openSnackbar('info', message, action, config);
  warning = (
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<CustomSnackbarComponent> =>
    this.openSnackbar('warning', message, action, config);
  success = (
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<CustomSnackbarComponent> =>
    this.openSnackbar('success', message, action, config);
  error = (
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<CustomSnackbarComponent> =>
    this.openSnackbar('error', message, action, config);

  private openSnackbar = (
    type = 'info',
    message: string,
    action?: string,
    config?: MatSnackBarConfig
  ): MatSnackBarRef<CustomSnackbarComponent> => {
    this.duration = ['error', 'warning', 'success'].includes(type)
      ? 10000
      : 3000;

    config = config || new MatSnackBarConfig();

    return this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message,
        action,
        config,
        type,
      },
      duration: this.duration,
    });
  };
}
